import * as React from 'react'
import { useContext, useEffect, useRef, useState } from 'react'
import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  IconButton,
  ITextField,
  List,
  PrimaryButton,
  Separator,
  Spinner,
  SpinnerSize,
  Stack,
  Text,
  TextField
} from '@fluentui/react'
import { useBoolean } from '@fluentui/react-hooks'

import { historyDelete, historyList, historyRename, historyRead } from '../../api'
import { BotConversation, BotConversations } from '../../api/models'
import { AppStateContext } from '../../state/AppProvider'

import { GroupedChatHistory } from './ChatHistoryList'

import styles from './ChatHistoryPanel.module.css'
import useChatHistory from './ChatHistoryService'
import { mapDataSourceToUrlAgentName } from '#/pages/bot/utils'
import { useNavigate } from 'react-router-dom'

interface ChatHistoryListItemCellProps {
  item?: BotConversations
  onSelect: (item: BotConversations | null) => void,
  onHistoryItemRemove?: (item: BotConversations) => void
}

interface ChoicesSet {
  type: string
  id: string
  style: string
  choices: Choice[]
  placeholder: string
  value: string
}

interface Choice {
  title: string
  value: string
}

interface ChatHistoryListItemGroupsProps {
  groupedChatHistory: GroupedChatHistory[],
  onHistoryItemRemove?: (item: BotConversation) => void
}

const formatMonth = (month: string) => {
  const currentDate = new Date()
  const currentYear = currentDate.getFullYear()

  const [monthName, yearString] = month.split(' ')
  const year = parseInt(yearString)

  if (year === currentYear) {
    return monthName
  } else {
    return month
  }
}

const useContainerWidth = () => {
  const ref = useRef<HTMLDivElement>(null)
  const [width, setWidth] = useState(0)

  useEffect(() => {
    if (!ref.current) return

    const resizeObserver = new ResizeObserver(() => {
      if (ref.current) {
        setWidth(ref.current.offsetWidth)
      }
    })
    
    resizeObserver.observe(ref.current)
    return () => resizeObserver.disconnect()
  }, [])
  
  return [ref, width] as const
}

export const ChatHistoryListItemCell: React.FC<ChatHistoryListItemCellProps> = ({ item, onSelect, onHistoryItemRemove }) => {
  const navigate = useNavigate();
  const [containerRef, containerWidth] = useContainerWidth()
  const [isHovered, setIsHovered] = React.useState(false)
  const [edit, setEdit] = useState(false)
  const [editTitle, setEditTitle] = useState('')
  const [hideDeleteDialog, { toggle: toggleDeleteDialog }] = useBoolean(true)
  const [errorDelete, setErrorDelete] = useState(false)
  const [renameLoading, setRenameLoading] = useState(false)
  const [errorRename, setErrorRename] = useState<string | undefined>(undefined)
  const [textFieldFocused, setTextFieldFocused] = useState(false)
  const textFieldRef = useRef<ITextField | null>(null)
  const chatHistory  = useChatHistory();
  const appStateContext = React.useContext(AppStateContext)
  const isSelected = item?.id === appStateContext?.state.currentChat?.id
  const [isLoadingMessages, setIsLoadingMessages] = useState(false)
  const accessToken = localStorage.getItem('accessToken');
  const dialogContentProps = {
    type: DialogType.close,
    title: 'Are you sure you want to delete this item?',
    closeButtonAriaLabel: 'Close',
    subText: 'The history of this chat session will permanently removed.'
  }

  const modalProps = {
    titleAriaId: 'labelId',
    subtitleAriaId: 'subTextId',
    isBlocking: true,
    styles: { main: { maxWidth: 450 } }
  }

  if (!item) {
    return null
  }

  useEffect(() => {
    if (textFieldFocused && textFieldRef.current) {
      textFieldRef.current.focus()
      setTextFieldFocused(false)
    }
  }, [textFieldFocused])

  useEffect(() => {
    if (appStateContext?.state.currentChat?.id !== item?.id) {
      setEdit(false)
      setEditTitle('')
    }
  }, [appStateContext?.state.currentChat?.id, item?.id])

  const onDelete = async () => {
    const userId = localStorage.getItem('userId');
    const email = localStorage.getItem('email');

    const response = await historyDelete(item.id, email!, userId!, accessToken!)
    if (!response.ok) {
      setErrorDelete(true)
      setTimeout(() => {
        setErrorDelete(false)
      }, 5000)
    } else {
      onHistoryItemRemove?.(item);
      appStateContext?.dispatch({ type: 'DELETE_CHAT_ENTRY', payload: item.id })
      appStateContext?.dispatch({ type: 'CHAT_HISTORY_ITEM_DELETED'})

      //commenting due to CCRP change - later uncomment it
      //localStorage.removeItem("dataSource");
      //localStorage.removeItem("title");
      //localStorage.removeItem("historylistConId");
      //localStorage.removeItem("conversationId");
    }

    toggleDeleteDialog()
  }

  const onEdit = () => {  
    setEdit(true)
    setTextFieldFocused(true)
    setEditTitle(item?.title)
  }

  const handleSelectItem = async() => {
    setIsLoadingMessages(true)
    // const response = await historyRead(item.id,'','',accessToken!);
    // item.messages = response;
    // onSelect(item)
    localStorage.setItem("dataSource",item.dataSource);
    localStorage.setItem("title",item.title);
    localStorage.setItem("historylistConId",item.id);
    
    // try{
    //  let content= item.messages.map(s=>s).forEach(s=>{
    //    if (s.content.body) {

    //     let ddl = s.content.body.find((item: ChoicesSet) => item.type === 'Input.ChoiceSet')
    //     if (ddl) {
    //      s.content.body.find((item: ChoicesSet) => item.type === 'Input.ChoiceSet').disabled = "true"
    //     }
    //    }
    //  });

    //   item.messages.map(s => s.content).forEach(s => {


    //     if (s.body) {
    //       let ddl = s.body.find((item: ChoicesSet) => item.type === 'Input.ChoiceSet')

    //       if (ddl) {
    //         localStorage.setItem("isShowingFromHistory", "true");
           
    //       }    
          
    //       let lastMessage =item.messages[item.messages.length-1];

    //       let notSelectedDDL =item.messages[item.messages.length-1].content.body.find((item : ChoicesSet) => item.type === 'Input.ChoiceSet');

    //       if(notSelectedDDL){
    //         localStorage.setItem("notSelectedDDLFromHistory", "true");
    //         item.messages[item.messages.length - 1].content.body.find((item: ChoicesSet) => item.type === 'Input.ChoiceSet').disabled = "false"
    //       }
    //     }
    //   });
    // }
    try{
      // Import and use mapping function
      const agentUrlName = mapDataSourceToUrlAgentName(item.dataSource);
      
      // Navigate using React Router with messages in state
      navigate(`/agent/${agentUrlName}?conversationId=${item.id}`);
    }
    catch(err){
      console.log("error in setting conversation from history", err)
    }
    finally{
      setIsLoadingMessages(false)
    }
  }

  const maxChars = Math.max(22, Math.floor((containerWidth - 100) / 8))
  const truncatedTitle = item?.title?.length > maxChars 
    ? `${item.title.substring(0, maxChars)}...` 
    : item.title
  const dynamicMaxWidth = Math.min(80, 75 + Math.floor((containerWidth - 250) / 50))

  const handleSaveEdit = async (e: any) => {
    e.preventDefault()
    if (errorRename || renameLoading) {
      return
    }
    if (editTitle == item.title) {
      setErrorRename('Error: Enter a new title to proceed.')
      setTimeout(() => {
        setErrorRename(undefined)
        setTextFieldFocused(true)
        if (textFieldRef.current) {
          textFieldRef.current.focus()
        }
      }, 5000)
      return
    }
    setRenameLoading(true)
    const userId = localStorage.getItem('userId');
    const email = localStorage.getItem('email');
    const accessToken = localStorage.getItem('accessToken');

    const response = await historyRename(item.id, editTitle, email!, userId!, accessToken!)
    if (!response.ok) {
      setErrorRename('Error: could not rename item')
      setTimeout(() => {
        setTextFieldFocused(true)
        setErrorRename(undefined)
        if (textFieldRef.current) {
          textFieldRef.current.focus()
        }
      }, 5000)
    } else {
      setRenameLoading(false)
      setEdit(false)
      appStateContext?.dispatch({ type: 'UPDATE_CHAT_TITLE', payload: { ...item, title: editTitle } as BotConversations })
      setEditTitle('')
    }
  }

  const chatHistoryTitleOnChange = (e: any) => {
    setEditTitle(e.target.value)
  }

  const cancelEditTitle = () => {
    setEdit(false)
    setEditTitle('')
  }

  const handleKeyPressEdit = (e: any) => {
    if (e.key === 'Enter') {
      return handleSaveEdit(e)
    }
    if (e.key === 'Escape') {
      cancelEditTitle()
      return
    }
  }

  return (
    <div
      ref={containerRef}
      key={item.id}
      tabIndex={0}
      aria-label="chat history item"
      className={styles.itemCell}
      onClick={() => handleSelectItem()}
      onKeyDown={e => (e.key === 'Enter' || e.key === ' ' ? handleSelectItem() : null)}
      // horizontal
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
          backgroundColor: isSelected ? '#e6e6e6' : 'transparent'
        }
      }>
      {edit ? (
        <>
          <Stack.Item style={{ width: '100%' }}>
            <form aria-label="edit title form" onSubmit={e => handleSaveEdit(e)} style={{ padding: '5px 0px' }}>
              <Stack horizontal verticalAlign={'start'}>
                <Stack.Item style={{ width: '80%' }}>
                  <TextField
                    componentRef={textFieldRef}
                    autoFocus={textFieldFocused}
                    value={editTitle}
                    placeholder={item.title}
                    onChange={chatHistoryTitleOnChange}
                    onKeyDown={handleKeyPressEdit}
                    // errorMessage={errorRename}
                    disabled={errorRename ? true : false}
                  />
                </Stack.Item>
                {editTitle && (
                  <Stack.Item>
                    <Stack aria-label="action button group" horizontal verticalAlign={'center'}>
                      <IconButton
                        role="button"
                        disabled={errorRename !== undefined}
                        onKeyDown={e => (e.key === ' ' || e.key === 'Enter' ? handleSaveEdit(e) : null)}
                        onClick={e => handleSaveEdit(e)}
                        aria-label="confirm new title"
                        iconProps={{ iconName: 'CheckMark' }}
                        styles={{ root: { color: 'green', marginLeft: '5px' } }}
                      />
                      <IconButton
                        role="button"
                        disabled={errorRename !== undefined}
                        onKeyDown={e => (e.key === ' ' || e.key === 'Enter' ? cancelEditTitle() : null)}
                        onClick={() => cancelEditTitle()}
                        aria-label="cancel edit title"
                        iconProps={{ iconName: 'Cancel' }}
                        styles={{ root: { color: 'red', marginLeft: '5px' } }}
                      />
                    </Stack>
                  </Stack.Item>
                )}
              </Stack>
              {errorRename && (
                <Text
                  role="alert"
                  aria-label={errorRename}
                  style={{ fontSize: 12, fontWeight: 400, color: 'rgb(164,38,44)' }}>
                  {errorRename}
                </Text>
              )}
            </form>
          </Stack.Item>
        </>
      ) : (
        <>
          <Stack horizontal verticalAlign={'center'} style={{ width: '100%' }}>
            <div className={styles.chatTitle} style={{ maxWidth: `${dynamicMaxWidth}%` }} title={item.title}>{truncatedTitle}</div>
            {isLoadingMessages && (
              <Spinner 
                size={SpinnerSize.small} 
                aria-label="loading messages"
                style={{ marginLeft: 'auto', marginRight: '10px' }}
              />
            )}
            {(isSelected || isHovered) && (
              <Stack horizontal horizontalAlign="end">
                <IconButton
                  className={styles.itemButton}
                  iconProps={{ iconName: 'Delete' }}
                  title="Delete"
                  onClick={toggleDeleteDialog}
                  onKeyDown={e => (e.key === ' ' ? toggleDeleteDialog() : null)}
                />
                <IconButton
                  className={styles.itemButton}
                  iconProps={{ iconName: 'Edit' }}
                  title="Edit"
                  onClick={onEdit}
                  onKeyDown={e => (e.key === ' ' ? onEdit() : null)}
                />
              </Stack>
            )}
          </Stack>
        </>
      )}
      {errorDelete && (
        <Text
          styles={{
            root: { color: 'red', marginTop: 5, fontSize: 14 }
          }}>
          Error: could not delete item
        </Text>
      )}
      <Dialog
        hidden={hideDeleteDialog}
        onDismiss={toggleDeleteDialog}
        dialogContentProps={dialogContentProps}
        modalProps={modalProps}>
        <DialogFooter>
          <PrimaryButton className={styles.primaryBtn} onClick={onDelete} text="Delete" />
          <DefaultButton className={styles.primaryBtn} onClick={toggleDeleteDialog} text="Cancel" />
        </DialogFooter>
      </Dialog>
    </div>
  )
}

export const ChatHistoryListItemGroups: React.FC<ChatHistoryListItemGroupsProps> = ({ groupedChatHistory, onHistoryItemRemove }) => {
  const appStateContext = useContext(AppStateContext)
  const observerTarget = useRef(null)

  const [offset, setOffset] = useState<number>(25)
  const [observerCounter, setObserverCounter] = useState(0)
  const [showSpinner, setShowSpinner] = useState(false)
  const firstRender = useRef(true)

  const handleSelectHistory = (item?: BotConversations) => {
    if (item) {
      appStateContext?.dispatch({ type: 'UPDATE_CURRENT_CHAT', payload: item })
    }
  }

  const onRenderCell = (item?: BotConversations) => {
    return <ChatHistoryListItemCell item={item} onSelect={() => handleSelectHistory(item)} onHistoryItemRemove={onHistoryItemRemove} />
  }

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false
      return
    }
    handleFetchHistory()
    setOffset(offset => (offset += 25))
  }, [observerCounter])

  const handleFetchHistory = async () => {
    const currentChatHistory = appStateContext?.state.chatHistory
    setShowSpinner(true)
    const userId = localStorage.getItem('userId');
    const email = localStorage.getItem('email');
    const accessToken = localStorage.getItem('accessToken');

    if(!accessToken){
      return null;
    }

    try{
      const response = await historyList(offset, email!,userId!, accessToken!);
      const concatenatedChatHistory = currentChatHistory && response && currentChatHistory.concat(...response)

      if (response) {
        appStateContext?.dispatch({ type: 'FETCH_CHAT_HISTORY', payload: concatenatedChatHistory || response })
      } else {
        appStateContext?.dispatch({ type: 'FETCH_CHAT_HISTORY', payload: null })
      }
      setShowSpinner(false)
      return response
    }catch(err){
      console.error("Error fetching chat history:", err);
      setShowSpinner(false)
      return null;
    }
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) setObserverCounter(observerCounter => (observerCounter += 1))
      },
      { threshold: 1 }
    )

    if (observerTarget.current) observer.observe(observerTarget.current)

    return () => {
      if (observerTarget.current) observer.unobserve(observerTarget.current)
    }
  }, [observerTarget])

  return (
    <div className={styles.listContainer} data-is-scrollable>
      {groupedChatHistory.map(
        group =>
          group.entries.length > 0 && (
            <Stack
              horizontalAlign="start"
              verticalAlign="center"
              key={group.month}
              className={styles.chatGroup}
              aria-label={`chat history group: ${group.month}`}>
              <Stack aria-label={group.month} className={styles.chatMonth}>
                {formatMonth(group.month)}
              </Stack>
              <List
                aria-label={`chat history list`}
                items={group.entries}
                onRenderCell={onRenderCell}
                className={styles.chatList}
              />
              <div ref={observerTarget} />
              <Separator
                styles={{
                  root: {
                    width: '100%',
                    position: 'relative',
                    '::before': {
                      backgroundColor: '#d6d6d6'
                    }
                  }
                }}
              />
            </Stack>
          )
      )}
      {showSpinner && (
        <div className={styles.spinnerContainer}>
          <Spinner size={SpinnerSize.small} aria-label="loading more chat history" className={styles.spinner} />
        </div>
      )}
    </div>
  )
}
